import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ReservationService } from '@rocksoft/inroom-sdk';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  AttributesActionTypes,
  AttributesActionUnion,
  AttributesApiAttributesLoaded,
  AttributesApiAttributesLoadedError,
  AttributesApiAttributesUpdated,
  AttributesApiAttributesUpdatedError,
  AttributesResolverAttributesRequested,
  AttributesViewSaveAttributes,
} from './attributes.actions';

@Injectable()
export class AttributesEffects {
  private readonly actions$ = inject<Actions<AttributesActionUnion>>(Actions);
  private readonly reservationService = inject(ReservationService);

  resolveAttributesEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AttributesActionTypes.ATTRIBUTES_RESOLVER_ATTRIBUTES_REQUESTED),
      mergeMap((action: AttributesResolverAttributesRequested) =>
        this.reservationService
          .getattributesByReservationId({ reservationId: action.payload.reservationId, getAttributesApiModel: {} })
          .pipe(
            map(
              (result) =>
                new AttributesApiAttributesLoaded({
                  attributes: {
                    reservationId: action.payload.reservationId,
                    attributes: result?.Data ?? [],
                  },
                })
            ),
            catchError((error) => of(new AttributesApiAttributesLoadedError({ error })))
          )
      )
    );
  });

  saveAttributesEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AttributesActionTypes.ATTRIBUTES_VIEW_SAVE_ATTRIBUTES),
      mergeMap((action: AttributesViewSaveAttributes) =>
        this.reservationService
          .updateattributes({
            updateAttributesApiModel: {
              ReservationId: +action.payload.attributes.reservationId,
              Attributes: action.payload.attributes.attributes,
            },
          })
          .pipe(
            map(() => new AttributesApiAttributesUpdated({ attributes: action.payload.attributes })),
            catchError((error) =>
              of(
                new AttributesApiAttributesUpdatedError({
                  originalAttributes: action.payload.attributes,
                  attributes: action.payload.attributes,
                  error: error,
                })
              )
            )
          )
      )
    );
  });
}
